import { render } from "./LeadGenerationReport.vue?vue&type=template&id=327cebfe&scoped=true"
import script from "./LeadGenerationReport.vue?vue&type=script&lang=js"
export * from "./LeadGenerationReport.vue?vue&type=script&lang=js"

import "./LeadGenerationReport.vue?vue&type=style&index=0&id=327cebfe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327cebfe"]])

export default __exports__